<template>
    <div class="ressource-not-found-container">
        <v-card class="ressource-not-found-card" elevation="0">
            <v-card-text class="text-center not-found-content">
                <div class="not-found-illustration mb-4"><MasterSvg use="noresult" /></div>
                <h1 class="font-weight-bold mb-3 not-found-title">
                    {{ $translate("notFoundTitle") }}
                </h1>
                
                <p class="text-body-1 mb-4 grey--text text--darken-1">
                    {{ $translate("notFoundMessage") }}
                </p>
                

                
                <div class="not-found-actions">
                    <v-btn
                        color="grey"
                        class="w-100 w-sm-auto"
                        outlined
                        @click="$router.go(-1)"
                    >
                        <v-icon left small>mdi-arrow-left</v-icon>
                        {{ $translate('back') }}
                    </v-btn>
                    <v-btn
                        color="primary"
                        class="w-100 w-sm-auto"
                        @click="$router.push({ name: 'dashboard' })"
                    >
                        <v-icon left small>mdi-home</v-icon>
                        {{ $translate('goToHome') }}
                    </v-btn>
                </div>
                <Info collapsible :title="$translate('possibleReasons')" class="text-left mt-5 mb-5">
                    <ul class="text-body-2">
                        <li>{{ $translate("reason1") }}</li>
                        <li>{{ $translate("reason2") }}</li>
                        <li>{{ $translate("reason3") }}</li>
                        <li>{{ $translate("reason4") }}</li>
                    </ul>
                </Info>
                <v-alert
                    v-if="message"
                    type="warning"
                    outlined
                    class="mt-6 mb-6"
                    text
                >
                    <div class="text-left">
                        {{ message }}
                    </div>
                </v-alert>
                
                <p class="text-body-2 mb-2 grey--text">
                    {{ $translate("helpMessage") }}
                </p>
                <div>
                    <p class="text-body-2 mb-2 d-flex align-center justify-center">
                        <v-icon small class="mr-2">mdi-email</v-icon>
                        <a href="mailto:support@safetee.io" class="support-link">support@safetee.io</a>
                    </p>
                    <p class="text-body-2 mb-0 d-flex align-center justify-center">
                        <v-icon small class="mr-2">mdi-phone</v-icon>
                        <a href="tel:+33972195305" class="support-link">+33 9 72 19 53 05</a>
                    </p>
                </div>
                
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: String,
            default: null,
        },
    },
    i18n: {
        messages: {
            en: {
                notFoundTitle: "Resource not found",
                notFoundMessage: "The resource you are looking for does not exist or is no longer available.",
                possibleReasons: "Possible reasons",
                reason1: "The resource has been deleted",
                reason2: "The URL is incorrect or outdated",
                reason3: "You do not have permission to access this resource",
                reason4: "You are connected with an account that is not linked to this resource",
                helpMessage: "If you think this is an error, please contact your administrator or the Safetee support.",
                back: "Back",
                goToHome: "Go to home",
            },
            fr: {
                notFoundTitle: "Ressource introuvable",
                notFoundMessage: "La ressource que vous recherchez n'existe pas ou n'est plus disponible.",
                possibleReasons: "Raisons possibles",
                reason1: "La ressource a été supprimée",
                reason2: "L'URL est incorrecte ou obsolète",
                reason3: "Vous n'avez pas la permission d'accéder à cette ressource",
                reason4: "Vous êtes connecté avec un compte qui n'est pas lié à cette ressource",
                helpMessage: "Si vous pensez qu'il s'agit d'une erreur, veuillez contacter votre administrateur ou le support Safetee.",
                back: "Retour",
                goToHome: "Retour à l'accueil",
            },
        },
    },
};
</script>

<style scoped>
.not-found-content { padding: 28px !important; }
.not-found-actions { display: flex; justify-content: center; flex-wrap: wrap; gap: 12px; margin-top: 24px; }
.not-found-actions .v-btn { text-transform: none; letter-spacing: normal; }
@media (max-width: 599px) {
    .not-found-content { padding: 20px 16px !important; }
    .not-found-title { font-size: 24px !important; }
    .not-found-actions { flex-direction: column-reverse; gap: 8px; }
}

.ressource-not-found-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
    padding: 0px;
}

.ressource-not-found-card {
    max-width: 560px;
    width: 100%;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.not-found-illustration {
    display: flex;
    justify-content: center;
    align-items: center;
}

.not-found-title {
    color: #1e293b;
    font-size: 26px;
    line-height: 1.25;
}

ul {
    margin-left: 0;
    padding-left: 20px;
}

li {
    margin-bottom: 4px;
}

.support-link {
    color: #1976d2;
    text-decoration: none;
    font-weight: 500;
}

.support-link:hover {
    text-decoration: underline;
}
</style>

